<template>
    <div>
        <div class="card">
            <div style="text-align: center;" class="card-heading-text bg-green card-text p-2">
                Document Data
            </div>
            <div class="card-body p-2">
                <div v-if="revision_data != null">
                    <b-row>
                        <b-col cols="12" class="mb-1">
                            <span class="bold">Title</span>
                            <div>{{ revision_data.title }}</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="mb-1">
                            <span class="bold ">Issue Date</span>
                            <div>{{ issueDate }}</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <span class="bold">Author</span>
                            <div>{{ revision_data.author }}</div>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <b-row>
                        <b-col cols="4" class="mb-2">
                            <label  class="mt-1" for="">Title:</label>
                        </b-col>
                        <b-col cols="8">
                            <!--<span class="ms-2 ps-1 pe-1 text-truncate" contenteditable="true" style="width: 60%; border-bottom: 1px solid black;">Add document title</span>-->
                            <b-form-input id="sopTitle" ref="titleInput" size="sm"></b-form-input>
                        </b-col>
                    </b-row>
                </div>

                <hr>

                <!-- builder mode toggle -->
                <b-row>
                    <b-col>
                        <span class="bold">
                            Document Mode
                        </span>
                        <div class="btn-group">
                            <b-button size="sm" @click="document_builder_enabled = !document_builder_enabled" :variant="document_builder_enabled ? 'primary' : 'outline-dark'">
                                Builder
                            </b-button>
                            <b-button size="sm" @click="document_builder_enabled = !document_builder_enabled" :variant="document_builder_enabled ? 'outline-dark' : 'primary'">
                                Uploader
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
                

            </div>
        </div>

        
        <div class="card" v-if="isAdmin">
            <div style="text-align: center;" class="bg-green card-text p-2 mb-0">
                Merge Keys
            </div>
            <div class="">
                <b-collapse v-if="show_table" visible id="merge-keys">
                    <webix-ui :config="ui" v-model="merge_keys"></webix-ui>
                </b-collapse>
            </div>
        </div>
    </div>
</template>

<script>
import { sopAdminState, sopAdminMethods, clientAdminState} from '@/state/helpers.js'
import { DateTime } from "luxon";
export default {
    data:() => ({
        revision_data: null,
        show_table: false,
        document_builder_enabled: true,
        ui:{
            id: 'mergeKeyTable',
            view:'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            hover: 'table_hover',
            autoheight: true,
            fillspace: true,

            columns:[
                /*{ id:"name", header:[
                    "Item", { content: 'textFilter', colspan: 2, placeholder: 'Search...'}
                ], fillspace: 1},*/
                { id: 'name', header:['Item', {content:"textFilter", placeholder:"Search items", colspan:2}], fillspace: 1, },
                { id:"merge_key", header:"Action", fillspace: 0.5,
                    template: '<button type="button" class="btn btn-primary btn-sm insert-button">Insert</button>'
                },
            ],
            on: {
                onItemClick(id){
                    var item = this.getItem(id)
                    console.log(item);
                }
            },
            onClick:{
                //eslint-disable-next-line
                "insert-button":function(event, cell, target){
                    let item = this.getItem(cell);
                    let merge_key = item.merge_key;
                    let el = this.$scope.$parent;
                    el.$eventHub.$emit('insertMergeKey', merge_key);
                    return false; // here it blocks the default behavior
                }
            },
        },
    }),
    methods:{
        ...sopAdminMethods,
        initWebixSearch(){
            function isEq(a,b){
                if(a == null){
                    return false;
                }
                a = a.toString().toLowerCase();
                return a.indexOf(b) !== -1;
            }
            //eslint-disable-next-line
            $$("mergeKeyTable").filterByAll=function(){
                //get filter values
                if(this.getFilter("name") == null){
                    return false;
                }
                else{
                    var text = this.getFilter("name").value.toString().toLowerCase();
                    //unfilter for empty search text
                    if (!text) return this.filter();

                    //filter using OR logic
                    this.filter(function(obj){

                        if (isEq(obj.name, text)){
                            return true;
                        }
                        if (isEq(obj.description, text)) {
                            return true;
                        }
                        return false;
                    });
                }
            }
        },
        updateRevisionData(revision){
            this.revision_data = revision;
        }
    },
    computed:{
        ...sopAdminState,
        ...clientAdminState,
        merge_keys(){
            let data = [];
            if(this.sop_data != null){
                data = this.sop_data.merge_keys;
            }
            return data;
        },
        hasSopData(){
            //* return true or false -- false == new sop
            if(this.sop_data == null){
                return false;
            }
            else{
                return true;
            }
        },
        isAdmin(){
            //* is user a ccb admin
            let show = false;
            if(this.core_data != null){
                show = this.core_data.ccb_admin
            }
            return show;
        },
        issueDate() {
            //return format(new Date(this.revision_data.issue_date), 'MM/DD/YYYY');
            var date = DateTime.fromISO(this.revision_data.issue_date);
            return date.toLocaleString(DateTime.DATETIME_MED);
        }
    },
    mounted(){
        this.ui.id = window.webix.uid();
        this.$eventHub.$on('updatedRevisionData', this.updateRevisionData);
        this.show_table = true;
    },
    beforeDestroy(){
        this.$eventHub.$off('updatedRevisionData');
    }
}
</script>

<style>
#notesDropdown>.btn{
    text-decoration: underline;
    border: 0px;
    padding: 0px;
    font-family: var(--bs-font-sans-serif);
    font-size: 0.8125rem;
    transition: all 0.1s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.fa-times{
    transition: all 0.1s linear;
    cursor: pointer;
}
.fa-times:hover{
    color: var(--bs-yellow)!important;
    /*transform: rotate(90deg);*/
    transition: all 0.1s linear;

}

.table_hover{
    background-color: rgba(164, 255, 164, 0.432);
}

.bg-green{
    background: radial-gradient(90.79% 1306.93% at 74.93% 34.21%, #05B15F 0%, #019750 100%);
}
.card-text{
    padding-top: 0.4rem;
    margin-bottom: 0.2rem;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 18px;
    color: #FFFFFF;
    text-align: center;
}
</style>